export default {
  "create-success": {
    EN: "Map created successfully",
  },
  "create-failure": {
    EN: "Failed to create map",
  },
  "delete-success": {
    EN: "Map deleted successfully",
  },
  "delete-failure": {
    EN: "Failed to delete map",
  },
  "proposal-create-success": {
    EN: "Proposal created successfully",
  },
  "proposal-create-failure": {
    EN: "Failed to create proposal",
  },
  "sync-measurements-success": {
    EN: "Measurements saved successfully",
  },
  "sync-measurements-failure": {
    EN: "Failed to save measurements",
  },
  "update-success": {
    EN: "Map updated successfully",
  },
  "update-failure": {
    EN: "Failed to update map",
  },
};
